var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 88,
    viewBox: "0 0 298 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293 88V6C283 6 237.5 6.49991 230 6.49991C223.424 6.49992 185.5 7 175.5 9.5C154 12.9999 151 18.4999 114.5 30.9999C78 43.4999 60.5 48.9999 6 59V88H293Z",
    fill: "url(#paint0_linear_126_8119)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53958 59.3957C48.2733 52.0693 72.3601 45.9137 107.802 34.4317C137.445 24.8282 144.5 14 197 7H291.5",
    stroke: "url(#paint1_linear_126_8119)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 7,
    r: 4,
    fill: "#1CD774"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 7,
    r: 5.5,
    stroke: "#1CD774",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 197,
    cy: 7,
    r: 4,
    fill: "#1CD774"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 197,
    cy: 7,
    r: 5.5,
    stroke: "#1CD774",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 59,
    r: 4,
    fill: "#3E65EF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 59,
    r: 5.5,
    stroke: "#3E65EF",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 37,
    r: 4,
    fill: "#3E65EF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 37,
    r: 5.5,
    stroke: "#3E65EF",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 87V59",
    stroke: "#F6F8FA",
    strokeDasharray: "2 2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101 87V40",
    stroke: "#F6F8FA",
    strokeDasharray: "2 2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197 87V14",
    stroke: "#F6F8FA",
    strokeDasharray: "2 2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M293 87V13",
    stroke: "#F6F8FA",
    strokeDasharray: "2 2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_8119",
    x1: 149,
    y1: -10.5001,
    x2: 149,
    y2: 96.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E65EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F8FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_126_8119",
    x1: -56,
    y1: 71.5,
    x2: 291.939,
    y2: 6.67228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E95EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506574,
    stopColor: "#3E65EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688435,
    stopColor: "#BDFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738476,
    stopColor: "#56E64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CD774"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart2);
export default __webpack_public_path__ + "static/media/chart2.90d4871f96f0021dcc066d19161b1103.svg";
export { ForwardRef as ReactComponent };